const productWrapper = document.querySelectorAll('.product-converter__content')
const stickyAddtoCart = document.querySelectorAll('.sticky-add-to-cart')
const productCards = document.querySelectorAll('.c-product-card')
let qtyInput = null
let qtyPlus = null
let qtyMinus = null

//for product page
if (productWrapper.length === 1) {
  qtyInput = productWrapper[0].querySelector('.quantity input')
  qtyPlus = productWrapper[0].querySelector('button[name="plus"]')
  qtyMinus = productWrapper[0].querySelector('button[name="minus"]')

  const qtyUpdates = (quantity) => {
    productWrapper[0].querySelector('.quantity input').value = quantity
    productWrapper[0].querySelector('#quantity').value = quantity
  }

  if (qtyInput) {
    let quantity = parseInt(qtyInput.value)

    qtyPlus.addEventListener('click', function () {
      quantity = quantity + 1
      qtyUpdates(quantity)
    })

    qtyMinus.addEventListener('click', function () {
      if (quantity > 1) {
        quantity = quantity - 1
        qtyUpdates(quantity)
      }
    })
  }
}

const numberWithCommas = (x) => {
  return x
    .toFixed(2)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

//for sticky add to cart
if (stickyAddtoCart.length === 1) {
  qtyInput = stickyAddtoCart[0].querySelector('.quantity input')
  qtyPlus = stickyAddtoCart[0].querySelector('button[name="plus"]')
  qtyMinus = stickyAddtoCart[0].querySelector('button[name="minus"]')

  const qtyUpdates = (quantity) => {
    stickyAddtoCart[0].querySelector('.quantity input').value = quantity
    stickyAddtoCart[0].querySelector('#quantity').value = quantity

    const handle = stickyAddtoCart[0].querySelector('#product-handle').value
    console.log(handle)

    fetch('/products/' + handle + '.js') // Call the fetch function passing the url of the API as a parameter
      .then((res) => res.json())
      .then(function (res) {
        var price = (quantity * res.price) / 100.0
        console.log(price)
        console.log(`${currency}${numberWithCommas(price)}`)
        stickyAddtoCart[0].querySelector(
          '.button--add-to-cart__price'
        ).innerHTML = `${currency}${numberWithCommas(price)}`
      })
      .catch(function () {
        // This is where you run code if the server returns any errors
      })
  }

  if (qtyInput) {
    let quantity = parseInt(qtyInput.value)

    qtyPlus.addEventListener('click', function () {
      quantity = quantity + 1
      qtyUpdates(quantity)
    })

    qtyMinus.addEventListener('click', function () {
      if (quantity > 1) {
        quantity = quantity - 1
        qtyUpdates(quantity)
      }
    })
  }
}

// //for product card
if (productCards.length) {
  for (let i = 0; i < productCards.length; i++) {
    qtyInput = productCards[i].querySelector('input[name="quantity"]')
    qtyPlus = productCards[i].querySelector('button[name="plus"]')
    qtyMinus = productCards[i].querySelector('button[name="minus"]')

    const qtyUpdates = (quantity) => {
      productCards[i].querySelector('#quantity').value = quantity
      productCards[i].querySelector('input[name="quantity"]').value = quantity
    }

    let quantity = parseInt(qtyInput.value)
    qtyPlus.addEventListener('click', function () {
      quantity = quantity + 1
      qtyUpdates(quantity)
    })

    qtyMinus.addEventListener('click', function () {
      if (quantity > 1) {
        quantity = quantity - 1
        qtyUpdates(quantity)
      }
    })
  }
}
